import { capitalize } from '@carboncopyco/utils';

type GetInfoTooltipTextParams = {
  assetType: 'demo' | 'tour' | 'playbook';
};

export function getInfoTooltipText({ assetType }: GetInfoTooltipTextParams) {
  return `${capitalize(assetType)} not available`;
}

export function hasProperties(obj) {
  return Object.keys(obj).length > 0;
}
